import { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';
import { checkIsAdmin, getUnreadTicketCount } from '../utils/supportUtils';

export default function Header({ user, currentPage, onNavigate }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    if (user) {
      checkAdminStatus();
    }
  }, [user]);

  useEffect(() => {
    if (user && isAdmin !== null) {
      const channel = supabase
        .channel('ticket-updates')
        .on(
          'postgres_changes',
          { event: '*', schema: 'public', table: 'ticket_messages' },
          () => setTimeout(() => loadUnreadCount(), 500)
        )
        .on(
          'postgres_changes',
          { event: '*', schema: 'public', table: 'support_tickets' },
          () => setTimeout(() => loadUnreadCount(), 500)
        )
        .on(
          'postgres_changes',
          { event: '*', schema: 'public', table: 'ticket_read_status' },
          () => setTimeout(() => loadUnreadCount(), 500)
        )
        .subscribe();

      return () => {
        supabase.removeChannel(channel);
      };
    }
  }, [user, isAdmin]);

  useEffect(() => {
    if (currentPage === 'support' && user) {
      setTimeout(() => loadUnreadCount(), 1000);
    }
  }, [currentPage, user]);

  useEffect(() => {
    const handleTicketRead = () => loadUnreadCount();
    window.addEventListener('ticketRead', handleTicketRead);
    return () => window.removeEventListener('ticketRead', handleTicketRead);
  }, []);

  const checkAdminStatus = async () => {
    if (!user?.email) return;
    const adminStatus = await checkIsAdmin(user.email);
    setIsAdmin(adminStatus);
    const { count } = await getUnreadTicketCount(user.id, user.email, adminStatus);
    setUnreadCount(count);
  };

  const loadUnreadCount = async () => {
    if (user && isAdmin !== null) {
      const { count } = await getUnreadTicketCount(user.id, user.email, isAdmin);
      setUnreadCount(count);
    }
  };

  const handleSignOut = async () => {
    try {
      const { error } = await supabase.auth.signOut();
      if (error) throw error;
    } catch (signOutError) {
      console.error('Sign out error:', signOutError);
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = '/login';
    }
  };

  const navigation = [
    { name: 'Dashboard', id: 'dashboard' },
    { name: 'Watch List', id: 'watchlist' },
    { name: 'Support', id: 'support', hasNotification: unreadCount > 0 },
    { name: 'Settings', id: 'settings' }
  ];

  return (
    <header className="topbar-wrap">
      <div className="topbar-inner">
        <button type="button" onClick={() => onNavigate('dashboard')} className="brand-mark">
          <span className="brand-icon">C</span>
          <div>
            <strong>CrypnAI</strong>
            <small>Trading Workspace</small>
          </div>
        </button>

        <nav className="topbar-nav desktop-nav">
          {navigation.map((item) => (
            <button
              key={item.id}
              onClick={() => onNavigate(item.id)}
              className={currentPage === item.id ? 'nav-pill active' : 'nav-pill'}
            >
              {item.name}
              {item.hasNotification && <span className="nav-dot" />}
            </button>
          ))}
          <button onClick={handleSignOut} className="btn-secondary topbar-signout">
            Sign Out
          </button>
        </nav>

        <button
          type="button"
          onClick={() => setIsMenuOpen((prev) => !prev)}
          className="mobile-toggle"
        >
          {isMenuOpen ? 'Close' : 'Menu'}
        </button>
      </div>

      {isMenuOpen && (
        <nav className="mobile-nav">
          {navigation.map((item) => (
            <button
              key={item.id}
              onClick={() => {
                onNavigate(item.id);
                setIsMenuOpen(false);
              }}
              className={currentPage === item.id ? 'nav-pill active' : 'nav-pill'}
            >
              {item.name}
              {item.hasNotification && <span className="nav-dot" />}
            </button>
          ))}
          <button onClick={handleSignOut} className="btn-secondary w-full">
            Sign Out
          </button>
        </nav>
      )}
    </header>
  );
}
